module.exports = __webpack_public_path__ + "static/media/paypal.cd135f4c.png";